import _ from "lodash";

export const isFacetedSearchEmpty = ({ facetSearch = {} }) => {
	const facetSearchValues = Object.values(facetSearch);

	return _.isEmpty(_.compact(facetSearchValues));
};
